<template>
  <div>
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <div>
        <div
          class="br-pagetitle d-flex justify-content-between align-items-center"
        >
          <div class="d-flex align-items-center">
            <i class="fa fa-sitemap"></i>
            <div class="mg-l-20 mg-b-0 d-flex align-items-center">
              <h4 class="mg-r-15">{{ $t("transfer.快递签收入库") }}</h4>
            </div>
          </div>
          <div class="tx-right"></div>
        </div>
        <div
          class="
            d-flex
            align-items-center
            justify-content-start
            pd-x-20 pd-sm-x-30
          "
        ></div>
      </div>
      <ul class="tabs">
        <li>
          <router-link to="/sign">{{ $t("transfer.快递签收") }}</router-link>
        </li>
        <li>
          <router-link to="/sign-check">{{
            $t("transfer.签收记录查询")
          }}</router-link>
        </li>
        <li class="shadow">
          <a class="active" href="javascript:;">{{
            $t("transfer.代客预报")
          }}</a>
        </li>
      </ul>
      <div>
        <div class="br-pagebody pd-x-20 pd-sm-x-30">
          <div class="card bd-gray-400 pd-30">
            <div class="form-group row mg-b-10">
              <label
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                  tx-white
                "
                >{{ $t("transfer.客户名称：") }}</label
              >
              <div class="col-md-6 col-sm-12">
                <select-distributor
                  class="mg-b-10"
                  :noLike="true"
                  :key_word="keyDistributorName"
                  @changeKeyword="changeName"
                  @keywordEnter="filtrateName"
                  @keywordFilter="filtrateNameDefault"
                />
              </div>
            </div>
            <div class="form-group row mg-b-10 align-items-center">
              <label
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                  tx-white
                "
                >{{ $t("transfer.国内快递单号：") }}</label
              >
              <div class="col-md-6 col-sm-12">
                <textarea
                  rows="3"
                  class="form-control form-control-sm"
                  :placeholder="
                    $t('transfer.可以填写多个快递单号，请用逗号隔开')
                  "
                  v-model="trackNumbers"
                ></textarea>
              </div>
            </div>
            <div class="form-group row mg-b-10 align-items-center">
              <label
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                  tx-white
                "
              ></label>
              <div class="col-md-6 col-sm-12 tx-center">
                <a href="javascript:;" class="btn btn-primary" @click="save">{{
                  $t("transfer.提交")
                }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <api-loading :show="loading"></api-loading>
  </div>
</template>

<script>
import SelectDistributor from "@components/supplier/select-distributor-2.vue"; //客户搜索
export default {
  data() {
    return {
      leftSideStatus: true, //左边栏状态
      loading: false,
      keyDistributorName: "",
      keyDistributorId: "",
      keyDistributorName1: "",
      keyDistributorId1: "",
      trackNumbers: "",
      distributorName: "",
      distributorId: "",
    };
  },
  components: {
    "select-distributor": SelectDistributor,
  },
  computed: {},
  watch: {},
  updated() {
    $('[data-toggle="tooltip-primary"]').tooltip({
      template:
        '<div class="tooltip tooltip-primary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
    });
  },
  methods: {
    save() {
      if (!this.trackNumbers) {
        ShowTip(this.$t("transfer.请填写快递单号"), "danger");
        return;
      }
      if (this.keyDistributorName != this.distributorName) {
        this.distributorId = "";
      }
      if (!this.distributorId) {
        ShowTip(this.$t("transfer.请选择一个客户"), "danger");
        return;
      }
      let trackNum = this.getStr(this.trackNumbers);
      console.log(trackNum);
      this.loading = true;
      $.api_call(
        "api.DistributorPackage.addBySupplier",
        {
          distributorId: this.distributorId,
          trackNumbers: trackNum,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("transfer.操作成功"), "success");
            this.keyDistributorName = "";
            this.keyDistributorId = "";
            this.keyDistributorName1 = "";
            this.keyDistributorId1 = "";
            this.trackNumbers = "";
            this.distributorName = "";
            this.distributorId = "";
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    getStr(str) {
      var temp = str.split(/[\n\s+,，]/g);
      for (var i = 0; i < temp.length; i++) {
        if (temp[i] == "") {
          temp.splice(i, 1);
          //删除数组索引位置应保持不变
          i--;
        }
      }
      return temp;
    },
    changeName(name, id) {
      console.log(1);
      this.keyDistributorName = name;
      this.keyDistributorId = id;
      //    if (name != this.distributor_name) this.keyDistributorId = "";
    },
    filtrateName(name, id) {
      console.log(2);
      if (name && name == this.distributor_name) {
        this.filtrate();
        return;
      }
      if (!id || id == "e999") {
        if (id == "e999")
          ShowTip(this.$t("transfer.没有匹配的供应商"), "danger");
        this.keyDistributorName = "";
        this.keyDistributorId = "";
      } else {
        //清空按供应商名
        this.keyDistributorName = name;
        this.keyDistributorId = id;
      }
      this.filtrate();
    },
    filtrateNameDefault(name, id) {
      console.log(3);
      this.keyDistributorName1 = name;
      this.keyDistributorId1 = id;
    },
    filtrate() {
      console.log(4);
      if (!this.keyDistributorId) {
        this.keyDistributorName = "";
        this.keyDistributorId = this.keyDistributorId1;
        this.keyDistributorName = this.keyDistributorName1;
        this.filtrate2(this.keyDistributorName1, this.keyDistributorId1);
      } else {
        if (!this.keyDistributorId1) {
          this.filtrate2(this.keyDistributorName, this.keyDistributorId);
        } else {
          this.keyDistributorName = "";
          this.keyDistributorId = this.keyDistributorId1;
          this.keyDistributorName = this.keyDistributorName1;
          this.filtrate2(this.keyDistributorName1, this.keyDistributorId1);
        }
      }
    },
    filtrate2(name, id) {
      console.log(5);
      this.distributorName = name;
      this.distributorId = id;
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.br-pagetitle .fa {
  font-size: 60px;
  line-height: 70px;
  color: #343a40;
}
.br-pagetitle i.fa {
  color: #17a2b8;
  font-size: 70px;
}
.show-white-style .br-pagetitle i.fa {
  color: #343a40;
}
.white-body .mode-change a .icon {
  color: #17a2b8;
}
.white-body .mode-change a.active .icon,
.white-body .mode-change a:hover .icon {
  color: #fff;
}
.nav.nav-tabs {
  .nav-item {
    background-color: #fff;
    .nav-link {
      border-bottom-color: #ddd;
    }
    .nav-link:active,
    .nav-link.active {
      border-bottom: 1px solid transparent;
      color: inherit;
      background-color: #fff;
    }
    .nav-link:focus {
      color: #868ba1;
    }
    .nav-link:hover {
      background-color: #f0f0f0;
      color: #868ba1;
    }
    .nav-link.active:hover {
      background-color: #fff;
    }
  }
}
.tab-content {
  border: 1px #ddd solid;
  border-top: none;
  padding: 0 15px;
  .tab-container.active {
    display: block;
  }
  .tab-container {
    display: none;
  }
}

.modal-content {
  .sku-list {
    h3 {
      margin-bottom: 5px;
      height: 26px;
      line-height: 26px;
      font-size: 14px;
    }
  }
  tbody {
    font-size: 12px;
  }
  .pro-info {
    display: flex;
    .img-wrap {
      margin-right: 5px;
      max-width: 60px;
      max-height: 60px;
      min-width: 60px;
      min-height: 60px;
      border: 1px #ddd solid;
      background-color: #fff;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }
    .right {
      display: flex;
      flex-flow: column;
      justify-content: space-between;
      max-width: 200px;
      min-width: 200px;
      line-height: 20px;
      .pro-attr {
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .table-wrap {
    margin-bottom: 15px;
  }
  .new-return-bottom {
    border-top: 1px #ddd solid;
    padding: 15px 15px 0;
  }
  textarea {
    resize: none;
  }
}
.info-wrap {
  padding-top: 15px;
  border-top: 1px solid #ddd;
}
.input-wrap {
  margin: 0 -15px;
  padding-top: 15px;
  border-top: 1px solid #ddd;
}
input[type="text"]:focus {
  box-shadow: 0 0 4px #55a6f8;
  background-color: #c4e0fd;
}
.br-pagetitle .fa {
  font-size: 60px;
  line-height: 70px;
  color: #343a40;
}
.form-control-dark:active,
.form-control-dark:focus {
  color: #343a40;
}
.show-white-style .form-control-dark:active,
.show-white-style .form-control-dark:focus {
  color: #343a40;
}
.mode-change .btn-info,
.mode-change .btn-info.active {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.mode-change .btn-info i,
.mode-change .btn-info.active i {
  color: #fff;
}
</style>

